import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';
import { GenericSubmissionField } from 'src/components/Submission/MySubmission/FormFieldGeneric/GenericSubmissionField';
import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';

const SubmissionFiles: React.FC<{
  entryPoint: 'adjudication' | 'early-assessment';
}> = ({ entryPoint }) => {
  const { isInviteRequestAccepted } =
    entryPoint === 'adjudication' ? useAdjudicationData() : useAssessmentData();

  return (
    <Flex flexDirection="column" gap={4}>
      {isInviteRequestAccepted() && (
        <Text textStyle="headingGroup">Submission Files</Text>
      )}

      <Flex gap={8} flexDirection="column">
        {isInviteRequestAccepted() && (
          <GenericSubmissionField
            entryPoint={entryPoint}
            fieldName="Manuscript"
            showSubtitle={false}
          />
        )}

        {isInviteRequestAccepted() && (
          <GenericSubmissionField
            entryPoint={entryPoint}
            fieldName="AnonymizedManuscript"
            showSubtitle={false}
          />
        )}

        {isInviteRequestAccepted() && (
          <GenericSubmissionField
            entryPoint={entryPoint}
            fieldName="Supplementary"
            showSubtitle={false}
          />
        )}
        {isInviteRequestAccepted() && (
          <GenericSubmissionField entryPoint={entryPoint} fieldName="Figures" />
        )}
        {isInviteRequestAccepted() && (
          <GenericSubmissionField entryPoint={entryPoint} fieldName="Tables" />
        )}
      </Flex>
    </Flex>
  );
};

export default SubmissionFiles;
